export const buildErrorBoundaryContext = (
  error: Error,
  componentStack?: string | null,
) => ({
  tags: { errorBoundary: 'true', errorType: error.name },
  contexts: { react: { componentStack: componentStack ?? undefined } },
});
